import apiClient from './client';
import type { Employee, SalaryRecord, PaginatedResponse, FilterParams } from '@/types';

export interface AllocationSummary {
  rd_cost: number;
  rd_days: number;
  project_cost: number;
  project_days: number;
  vehicle_cost: number;
  vehicle_days: number;
}

export interface SummaryDetailBucket {
  days: number;
  gross_salary: number;
  company_pension: number;
  company_unemployment: number;
  company_medical: number;
  company_injury: number;
  company_maternity: number;
  company_housing_fund: number;
}

export interface SummaryDetail {
  total: SummaryDetailBucket;
  used: SummaryDetailBucket;
  remaining: SummaryDetailBucket;
}

export const employeeApi = {
  getEmployees: async (params?: FilterParams): Promise<PaginatedResponse<Employee>> => {
    const response = await apiClient.get<PaginatedResponse<Employee>>('/employees/', { params });
    return response.data;
  },

  getEmployee: async (id: number): Promise<Employee> => {
    const response = await apiClient.get<Employee>(`/employees/${id}`);
    return response.data;
  },

  getSalaries: async (params?: FilterParams): Promise<PaginatedResponse<SalaryRecord>> => {
    const response = await apiClient.get<PaginatedResponse<SalaryRecord>>('/salaries/', { params });
    return response.data;
  },

  getSalarySummary: async (params?: FilterParams): Promise<SalaryRecord[]> => {
    const response = await apiClient.get<SalaryRecord[]>('/salaries/summary', { params });
    return response.data;
  },

  getAllocationSummary: async (params?: FilterParams): Promise<AllocationSummary> => {
    const response = await apiClient.get<AllocationSummary>('/salaries/allocation-summary', { params });
    return response.data;
  },

  getBusinessLines: async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>('/employees/business-lines');
    return response.data;
  },

  getSummaryDetail: async (params?: FilterParams): Promise<SummaryDetail> => {
    const response = await apiClient.get<SummaryDetail>('/salaries/summary-detail', { params });
    return response.data;
  },
};
